export enum Origin {
  Web = 'web',
}
